import { render, staticRenderFns } from "./card-template-list.vue?vue&type=template&id=308a1648&scoped=true"
import script from "./card-template-list.vue?vue&type=script&lang=ts"
export * from "./card-template-list.vue?vue&type=script&lang=ts"
import style0 from "./card-template-list.vue?vue&type=style&index=0&id=308a1648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a1648",
  null
  
)

export default component.exports